<template>
  <div class="cpsjj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">成品数据集</div>
          <div class="t22">
            支持全栈式大模型数据服务，包括数据集，模型评估，模型调优；同时，大模型智能开发平台与全套标注工具支持您快速部署大模型应用。
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">成品数据集</div>
      <div class="slogan">
        提供八百余个成品数据集，共有近十万小时的采集或网络公开的音频资源、五十余万幅图像和超过一亿字/词文本，涵盖80+种语言和方言。我们也在不断构建新的数据集，以满足全球企业用户的部署需求。
      </div>
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;align-items: stretch;">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <div class="contents">
              <div class="img-sx">
                <img
                  style="width: 48px;height: 48px;margin-bottom: 12px;"
                  :src="item.img"
                  alt=""
                />
              </div>
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
              <div style="color: #045588;margin-top: 48px;cursor: pointer;" @click="go('/callMe')">获取数据集</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card22">
      <div class="title">行业标注能力</div>
      <div class="slogan">
        数据标注团队支持多模态全行业的数据标注服务，支持您进行定制化模型训练。
      </div>
      <div class="w1280">
        <div class="flexs" style="flex-wrap: wrap;align-items: stretch;">
          <div class="card-sx" v-for="(item, index) in cardList11" :key="index">
            <img
              style="width: 405px;height: 192px;border-radius:8px 8px 0 0;"
              :src="item.img"
              alt=""
            />
            <div class="contents">
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">数据集列表</div>
      <div class="slogan">您可以搜索、筛选寻找您需要的数据集，并获得样例。</div>
      <div>
        <el-input
          placeholder="请输入内容"
          v-model="searchQuery"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchItems"
          ></el-button>
        </el-input>
        <el-table
          :data="paginatedData"
          style="width: 100%"
          stripe
          :header-cell-style="{
            background: '#045588',
            color: '#ededed',
            height: '56px',
          }"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <div
                  style="height: 32px;display: flex;justify-content: space-between;margin: 0 128px;"
                >
                  <el-form-item label="数据集名称 :">
                    <span>{{ props.row.name }}</span>
                  </el-form-item>
                  <el-form-item label="数据集编号 :">
                    <span>{{ props.row.num }}</span>
                  </el-form-item>
                </div>
                <div
                  style="height: 32px;display: flex;justify-content: space-between;margin: 0 128px;"
                >
                  <el-form-item label="内容简述 :">
                    <span>{{ props.row.name }}</span>
                  </el-form-item>
                  <el-form-item label="产品类型 :">
                    <span>{{ props.row.type }}</span>
                  </el-form-item>
                </div>
                <div
                  style="height: 32px;display: flex;justify-content: space-between;margin: 0 128px;"
                >
                  <el-form-item label="语言 :">
                    <span>{{ props.row.language }}</span>
                  </el-form-item>
                  <el-form-item label="国家 :">
                    <span>{{ props.row.country }}</span>
                  </el-form-item>
                </div>
                <div
                  style="height: 32px;display: flex;justify-content: space-between;margin: 0 128px;"
                >
                  <el-form-item label="采集设备:">
                    <span>{{ props.row.device }}</span>
                  </el-form-item>
                  <el-form-item label="采集环境:">
                    <span>{{ props.row.environment }}</span>
                  </el-form-item>
                </div>
                <div
                  style="height: 32px;display: flex;justify-content: space-between;margin: 0 128px;"
                >
                  <el-form-item label="单元（数据量级）:">
                    <span>{{ props.row.volume }}</span>
                  </el-form-item>
                  <el-form-item label="是否含有转写/标注:">
                    <span>{{ props.row.available }}</span>
                  </el-form-item>
                </div>
                <div
                  style="height: 32px;display: flex;justify-content: space-between;margin: 0 128px;"
                >
                  <el-form-item label="常见使用案例:">
                    <span>{{ props.row.cases }}</span>
                  </el-form-item>
                </div>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="数据集名称" prop="name"> </el-table-column>
          <el-table-column label="数据集编号" prop="num"> </el-table-column>
          <el-table-column label="产品类型" prop="type"> </el-table-column>
          <el-table-column label="语言" prop="language"> </el-table-column>
          <el-table-column label="国家" prop="country"> </el-table-column>
          <el-table-column label="常见应用场景" prop="scenarios">
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin: 40px auto;text-align: center;"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="tableData.length"
        >
        </el-pagination>
      </div>
    </div>
    <div class="card2">
      <div class="title">我们的数据集优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 0px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img
              style="width:48px;height:48px;margin-bottom:8px"
              :src="item.img"
              alt=""
            />
            <div class="t1">{{ item.name }}</div>
            <div class="t2">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <!-- <div class="title">成功案例</div> -->
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjj/e1.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">数据采集标注定制</div>
            <div style="line-height: 1.5;font-size: 18px;margin-bottom: 48px;">
              基于其大模型平台的多模态数据处理能力，为某 AI
              同时提供数据定制采标服务，如您未找到适合您的AI的成品数据集，可联系我们为您进行定制。我们涵盖全数据类型、全球范围的服务能力可以为您快速高效大规模地创建数据集。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="t1">高效部署模型</div>
      <div class="t2">700+数据集支持您快速高效部署AI模型</div>
      <div class="btns" @click="go('/callMe')">联系我们</div>
    </div>
  </div>
</template>
<script>
import userData from "../assets/table.json";
export default {
  data() {
    return {
      searchQuery: "",
      tableData: userData,
      allData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的条数
      ysList: [
        {
          name: "快速部署",
          content: "直接获取数据库产品快速为您部署AI与机器学习项目",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "低成本高效益",
          content:
            "直接获取经授权的成品数据库比您定制数据采集服务更具成本效益。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "专家团队",
          content: "您将拥有一支在数据采集领域耕耘近三十年的专家团队支持",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "支持所有数据类型",
          content: "图像，视频，语音，音频，文本",
          img: require("../assets/img/sjfw/e4.svg"),
        },
        {
          name: "大规模",
          content: "提供大量、高品质的数据高效地训练您的机器模型",
          img: require("../assets/img/sjfw/e4.svg"),
        },
        {
          name: "高质量",
          content: "提高您的机器模型质量并减少数据偏见",
          img: require("../assets/img/sjfw/e4.svg"),
        },
      ],
      cardList11: [
        {
          title: "安全驾驶/自动驾驶",
          img: require("../assets/img/sjj/w1.webp"),
          textList: [
            {
              title: "驾驶人危险行为识别数据库",
              content: "助力驾驶舱内检测驾驶位、驾驶员危险动作以及疲劳识别",
            },
            {
              title: "乘客安全监测数据库",
              content: "，助力识别被遗留的小孩、宠物、危害物品等",
            },
            {
              title: "车载语音数据库",
              content: "助力驾驶人实现语音导航、多元化智能驾驶体验",
            },
            {
              title: "驾驶舱外数据库",
              content: "助力道路车道线、障碍物、停车位识别",
            },
          ],
        },
        {
          title: "互联网虚拟人/智能客服",
          img: require("../assets/img/sjj/w2.webp"),
          textList: [
            {
              title: "线上NLP多轮对话的数据集",
              content: "助力实现生成类AI聊天程序，实现线上客服智能化",
            },
            {
              title: "TTS语音数据库",
              content:
                "对文本文件进行实时转换，把文本智能地转化为自然语音流，文本输出的语音音律流畅，使得听者在听取信息时感觉自然",
            },
          ],
        },
        {
          title: "智慧金融",
          img: require("../assets/img/sjj/w3.webp"),
          textList: [
            {
              title: "我们的金融 OCR 数据集",
              content:
                "可针对金融、保险的合同审核自动化，助力实现高效、精准的文本转写识别自动化",
            },
          ],
        },
        {
          title: "智能家居",
          img: require("../assets/img/sjj/w4.webp"),
          textList: [
            {
              title: "语音识别数据库",
              content: "，支持智能家居AI的智能交互",
            },
            {
              title: "障碍物图像数据库，",
              content: "助力例如扫地机器人的智能识别和障碍物跨越",
            },
          ],
        },
        {
          title: "智能终端",
          img: require("../assets/img/sjj/w5.webp"),
          textList: [
            {
              title: "人脸识别，语音识别",
              content: "等数据集可以助您部署智能终端",
            },
          ],
        },
        {
          title: "智能安防",
          img: require("../assets/img/sjj/w6.webp"),
          textList: [
            {
              title: "人脸识别，危险动作追踪等数据集",
              content: "可助您搭建智能安防人工智能",
            },
          ],
        },
      ],
      cardList1: [
        {
          name: "数据存储与传输",
          list: [
            { t: "国安级加密云技术保证数据传输和存储安全" },
            {
              t:
                "业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别",
            },
          ],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
          list: [
            { t: "项目现场配置人脸识别和指纹门禁" },
            {
              t:
                "设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别",
            },
            { t: "配有24*7值班人员以及无死角摄像头监控现场" },
          ],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list: [
            { t: "标注人员及供应商签署保密协议" },
            { t: "全体员工办公设备均统一管理" },
          ],
          img: require("../assets/img/sjfw/x3.svg"),
        },
      ],
      cardList: [
        {
          title: "语音识别数据集",
          img: require("../assets/img/sjj/q1.svg"),
          textList: [
            {
              title: "",
              content: "覆盖90余种语言，总时长近十万小时",
            },
            {
              title: "",
              content:
                "电话信道，手机，高保真麦克风等多种录音设备，以及网络数据清洗",
            },
            {
              title: "",
              content: "对话类的语音数据库80余个，量级10000+小时",
            },
            {
              title: "",
              content: "朗读类的语音数据库近120个，量级70000+小时",
            },
            {
              title: "",
              content: "自由说数据库20个，量级20000+小时",
            },
            {
              title: "",
              content:
                "特种数据库:0-3岁婴幼儿啼哭音频70小时;猫狗叫声数据库70小时;多领域儿童高保真唤醒词",
            },
          ],
        },
        {
          title: "大模型数据集",
          img: require("../assets/img/sjj/q2.svg"),
          textList: [
            {
              title: "",
              content: "81亿token l 千万词条的LLM数据集",
            },
            {
              title: "",
              content: "涵盖医学、金融、法律、教育、中文百科、代码等多领域",
            },
            {
              title: "",
              content: "逻辑推理数据集，包括思维链、多模态图表示意图分析等",
            },
            {
              title: "",
              content:
                "多模态数据集，包含百万条图文对或视频文本对，支持多种语言",
            },
            {
              title: "",
              content: "安全性问答数据集，支持大模型的毒性测试以及安全性训练",
            },
          ],
        },
        {
          title: "图像数据集",
          img: require("../assets/img/sjj/q3.svg"),
          textList: [
            {
              title: "",
              content: "总计六百万幅图片",
            },
            {
              title: "",
              content: "数百万的高质量多模态图文对数据集",
            },
            {
              title: "",
              content: "十余种不同语言的通用场景OCR图片数据集",
            },
            {
              title: "",
              content: "精标日语发票，992张",
            },
            {
              title: "",
              content:
                "特种数据库：电梯间电动车精标数据、多居室户型图集、汽车尾灯图片集、发丝分割数据集",
            },
          ],
        },
        {
          title: "文本数据集",
          img: require("../assets/img/sjj/q4.svg"),
          textList: [
            {
              title: "",
              content: "三十余万道含标注的的多学科题目集",
            },
            {
              title: "",
              content: "发音词典覆盖98种语言，共523万词条",
            },
            {
              title: "",
              content: "词性词典覆盖22种语言，共326万词条",
            },
            {
              title: "",
              content: "命名实体库(NER)覆盖8种语言，超100万词条",
            },
          ],
        },
        {
          title: "视频数据集",
          img: require("../assets/img/sjj/q5.svg"),
          textList: [
            {
              title: "",
              content: "东南亚各国人物朗读视频",
            },
            {
              title: "",
              content: "海量开源视频爬取数据集",
            },
          ],
        },
        {
          title: "语音合成数据集",
          img: require("../assets/img/sjj/q6.svg"),
          textList: [
            {
              title: "",
              content: "多种语言，400名声优，20+国家资深声优资源库",
            },
            {
              title: "",
              content: "覆盖多种不同情绪的音色及应用场景",
            },
          ],
        },
      ],
    };
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.tableData.slice(start, end);
    },
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage; // 更新当前页码
    },
    searchItems() {
      // 深拷贝数据
      if (this.searchQuery === "") {
        this.tableData = this.allData;
      } else {
        this.allData = JSON.parse(JSON.stringify(this.tableData));
      }
      this.tableData = this.tableData.filter((item) => {
        return Object.keys(item).some((name) => {
          return String(item[name])
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase());
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.cpsjj {
  ::v-deep .el-table__expanded-cell {
    background-color: #dff1ff !important;
    &:hover {
      background-color: #dff1ff !important;
    }
  }
  .table-header {
    background-color: #045588;
    color: #fff;
  }
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 370px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2 {
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card22 {
    width: 1280px;
    margin: 0 auto;
    .card-ys {
      width: 448px;
      height: 178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top: 24px;
      .t1 {
        font-size: 20px;
        color: #25282a;
        margin-bottom: 16px;
      }
      .t2 {
        font-size: 16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 405px;
      margin: 0 0 48px;
      background-color: #eceff0;
      .contents {
        padding: 24px;
        // height: 328px;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 24px;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .input-with-select {
      border: 1px solid rgb(75, 79, 84);
      margin-bottom: 20px;
    }
    .card-ys {
      width: 355px;
      height: 178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top: 24px;
      .t1 {
        font-size: 20px;
        color: #25282a;
        margin-bottom: 16px;
      }
      .t2 {
        font-size: 16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 400px;
      margin: 0 0 48px;
      background-color: #eceff0;
      .contents {
        padding: 24px;
        // height: 420px;
        border-radius: 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          line-height: 1.5;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    width: 250px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .title-1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
    }
    .title-2 {
      font-size: 16px;
      line-height: 1.5;
    }
    .title-11 {
      font-size: 28px;
      color: #444;
      line-height: 2;
      font-weight: 600;
    }
    .title-22 {
      font-size: 16px;
      color: #4b4f54;
      line-height: 1.5;
      margin-bottom: 16px;
    }
    li {
      margin-left: 24px;
      line-height: 1.5;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
